<template>
  <div class="pzhList-box">
    <!-- 扎比特饰品列表 -->

    <!-- 搜索 -->
    <el-row style="margin-bottom: 20px">
      <el-select
        style="width: 150px; margin-right: 20px"
        size="small"
        v-model="query.prizeType"
        placeholder="奖品分类"
        @change="getData()"
      >
        <el-option :value="1" label="csgo"></el-option>
      </el-select>
      <el-input
        style="width: 200px; margin-right: 20px"
        size="small"
        placeholder="商品名称搜索"
        v-model="query.keyword"
      ></el-input>
      <!-- <el-select
        style="width: 120px; margin-right: 20px"
        v-model="query.appearanceValue"
        placeholder="外观"
        size="small"
      >
        <el-option :value="undefined">不限</el-option>
        <el-option
          v-for="item in staticData.appearance"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        >
        </el-option>
      </el-select> -->
      <el-button
        style="margin-right: 20px"
        size="small"
        type="primary"
        @click="getData()"
        >搜索</el-button
      >
      <!-- <span class="pull-right">扎比特余额: {{ 123456 }}</span> -->
    </el-row>
    <!-- 列表 -->
    <div class="prize-list-wrap" v-loading="loadingPzhPrize" :data="pzhPrizeList.length">
      <ul class="prize-list" v-if="pzhPrizeList && pzhPrizeList.length > 0">
        <li class="prize-item" v-for="item in pzhPrizeList">
          <i
            class="buyIcon el-icon-view"
            title="购买"
            @click="buyPzh(item)"
          ></i>
          <p class="price-box">
            <span class="price">{{ item }}</span>
          </p>
        </li>
      </ul>
      <p
        class="null_tips"
        style="text-align: center; line-height: 100px"
        v-else
      >
        暂无数据
      </p>
    </div>

  </div>
</template>
<script>
import {
  mapActions,
  mapMutations,
  mapState
} from 'vuex'
import http, { patchData, server, postApiData, getApiData } from '@/http'
// import appearance from '@/assets/js/appearance'
// import mallUnique from '@/assets/js/mallUnique'
// import mallQuality from '@/assets/js/mallQuality'
// import mallClassification from '@/assets/js/mallClassification'

export default {
  props: {
    value: {
      type: Object,
      default: undefined
    }
  },
  data() {
    return {
      pzhSellProductVisible: false, //扎比特在售列表弹窗显示标志
      loading: false, //加载动画
      loadingPzhPrize: false, //pzh列表加载动画
      loadingPzhSellProduct: false, //pzh在售列表加载动画
      buttonLoading: false,//按钮加载动画
      buyLock: false,//防止购买重复点击锁
      buyGoodsId: undefined,//当前被购买物品的id
      query: {
        page: 1,//页数
        prizeType: 1,//奖品分类 1是csgo 5是dota2 ,默认是1
        keyword: undefined, //物品名称
        // appearanceValue: undefined, //外观
      },
      pzhSellquery: {
        page: 1,
        itemId: ''
      },
      staticData: {//引入外部的js静态数据
        // appearance: appearance,//物品外观/磨损度
        // mallUnique: mallUnique,//商城物品暗金
        // mallQuality: mallQuality,//商城物品品质
        // mallClassification: mallClassification,//商城物品种类
      },
      pzhPrizeList: undefined,//扎比特物品列表,
      pzhSellProductList: undefined,//扎比特在售物品列表
    }
  },
  computed: {
    ...mapState({
      boxCategories: (state) => state.data.boxCategories, //箱子分类数据
    }),
    infos: {
      get() {
        //拿到要查询的物品名字
        return this.value
      },
      set() { }
    }
  },
  watch: {
    infos: {
      // 监听传来的订单数据
      immediate: true, //监听首次
      handler: function (val) {
        //执行代码
        if (!val) {
          //不是购买物品而是选择物品时，不会传参进来，就直接查数据
          this.getData()//查询数据
        } else {
          this.query.keyword = val.shop_prize.name
          this.getData()//查询数据
        }
      }
    }
  },
  created() { },
  mounted() { },
  methods: {
    getData() {
      //获取pzh物品列表
      this.loadingPzhPrize = true
      let params = {
        keyword: this.query.keyword,
      }
      getApiData('pzh/search', params).then(res => {
        if (res.code == 0) {
          this.pzhPrizeList = res.data;
          this.loadingPzhPrize = false;
        }
      }).finally(() => {
        this.loadingPzhPrize = false;
        this.pzhPrizeList = undefined;
      })
    },
    buyPzh(price) {
      //购买扎比特商品
      if (this.buyLock) {
        //防止重复点击的锁
        this.$message.error("请求正在进行中，请勿重复点击")
        return
      }
      this.buyLock = true//加锁
      let params = {
        price: price,
        keyword: this.query.keyword,
      }
      postApiData('pzh/buy/' + this.infos.id, params)
        .then(res => {
          this.$message.success('购买成功')
          this.closePzhSellDialog() //关闭pzh在售列表弹窗
          this.closeThirdDialig()//关闭第三方物品弹窗
          this.$emit("refresh")//刷新列表
          this.buyLock = false//解锁
        }).catch(error => {
          this.buyLock = false//解锁
        })
    },
    closePzhSellDialog() {
      //关闭扎比特商品在售列表
      this.pzhSellProductVisible = false
    },
    closeThirdDialig() {
      //关闭第三方物品弹窗
      this.$emit("close")
    },
  }

}

</script>
<style lang="less" scoped>
.pzhList-box {
}
</style>
